import store from '@/store'
import { app } from '@/main.js'
import { useToast } from 'vue-toastification'
import router from '@/router'
import helper from '@/helpers/helper'


const toast = useToast()


export default (to, from, next) => {
  let isAdmin = false;

  if (app.helpers.getTokenParam()){
    store.commit('auth/setToken', app.helpers.getTokenParam());
  }

  if (store.state.auth.jwtPayload == null){
    store.dispatch('auth/logout');
    return;
  }

  if (store.state.auth.jwtPayload.organisation_role) {
    for (const product of store.state.auth.jwtPayload.organisation_role[0].products) {
      isAdmin = product.roles.includes("admin");
      if (isAdmin)
        break;
    }
  }

  if (!store.state.auth.isSuperAdmin && !helper.isVertexAnalyst() && !isAdmin && !store.state.auth.isManager && (store.state.user.organisation != null && !store.state.user.organisation.is_organisation_admin)) {
    toast.error("Only organisation admins are allowed to view this page.");
    return router.push('/training/assigned-training');
  }


  return next()
}

